import React, { useEffect, useState } from 'react';
import { CenterMissingPayment, PagingResult } from 'models';
import { Stack, Text, Title } from 'library/ui';
import { useClient } from 'shared';
import { TimesheetsTable } from './TimesheetsTable';

export function CenterMissingPaymentReports({
    locationId,
    small,
    timesheetRefresh,
}: {
    locationId?: string | number;
    small: boolean;
    timesheetRefresh: () => void;
}) {
    const [page, setPage] = useState(1);
    const {
        send: fetchMissingPayments,
        data: missingPayments,
        loading,
    } = useClient<PagingResult<CenterMissingPayment>>({
        url: `api/center-missing-payment/?location=${locationId}&page=${page}`,
        options: { sendImmediately: false },
    });

    useEffect(() => {
        fetchMissingPayments();
    }, [locationId, page]);

    if (!missingPayments?.results?.length) return null;

    return (
        <Stack gap="md">
            <Stack gap="sm">
                <Title size="h2">Missing Payments Reported ({missingPayments?.results?.length})</Title>
                <Text size="sm">
                    These workers have reported that they were missing payment for a shift at this center.{' '}
                    <b>
                        We do not have timesheets for these shifts, and all times were entered manually by the worker.
                    </b>{' '}
                    Please approve or deny all reports below.
                </Text>
            </Stack>
            <TimesheetsTable
                data={missingPayments}
                small={small}
                loading={loading}
                refresh={() => {
                    fetchMissingPayments();
                    timesheetRefresh();
                }}
                page={page}
                setPage={setPage}
            />
        </Stack>
    );
}
